import api from "../../../services/api.service"

export const contractModule = {
    namespaced: true,
    state: {
        contracts: [],
        contract: null,
        loading: false,
        page: 1,
        amount: 10,
        total: 0,
        totalRows: 0,
        unsignedContracts: [],
        hasUnsigned: false,
        unsignedChecked: false,
    },
    getters: {
        getContracts: state => state.contracts,
        getContract: state => state.contract,
        isLoading: state => state.loading,
        getPage: state => state.page,
        getAmount: state => state.amount,
        getTotal: state => state.total,
        getTotalRows: state => state.totalRows,
        getUnsignedContracts: state => state.unsignedContracts,
        hasUnsignedContracts: state => state.hasUnsigned,
        isUnsignedChecked: state => state.unsignedChecked,
    },
    mutations: {
        setContracts(state, data) {
            state.contracts = data.Contracts || [];
            state.page = data.Page || 1;
            state.amount = data.Amount || 10;
            state.total = data.Total || 0;
            state.totalRows = data.TotalRows || 0;
        },
        setContract(state, contract) {
            state.contract = contract;
        },
        setLoading(state, val) {
            state.loading = val;
        },
        setUnsignedContracts(state, contracts) {
            state.unsignedContracts = contracts || [];
            state.hasUnsigned = contracts && contracts.length > 0;
            state.unsignedChecked = true;
        },
        resetUnsignedCheck(state) {
            state.unsignedChecked = false;
            state.hasUnsigned = false;
            state.unsignedContracts = [];
        },
    },
    actions: {
        getContracts({ commit }, { page, amount, filter, sortcolumn, sortby }) {
            commit('setLoading', true);
            return new Promise((resolve, reject) => {
                api.sendRequest('contracts/get', { page, amount, sortcolumn, sortby }, filter)
                    .then(ans => {
                        commit('setContracts', ans);
                        commit('setLoading', false);
                        resolve(ans);
                    })
                    .catch(error => {
                        commit('setLoading', false);
                        reject(error.message || error);
                    });
            });
        },

        getContract({ commit }, { id }) {
            return new Promise((resolve, reject) => {
                api.get('contracts/id/' + id)
                    .then(ans => {
                        commit('setContract', ans.Contract || ans);
                        resolve(ans);
                    })
                    .catch(error => reject(error.message || error));
            });
        },

        createContract(actions, { branchId, leadId, language, contractType }) {
            return new Promise((resolve, reject) => {
                api.sendRequest('contracts/create', { branchId, leadId, language, contractType })
                    .then(ans => {
                        actions.dispatch('notifications/success', {
                            title: 'Success',
                            text: 'Contract created'
                        }, { root: true });
                        resolve(ans);
                    })
                    .catch(error => {
                        actions.dispatch('notifications/error', {
                            title: 'Error',
                            text: error.message || 'Failed to create contract'
                        }, { root: true });
                        reject(error.message || error);
                    });
            });
        },

        createAllContracts(actions, { branchId, leadId, language }) {
            return new Promise((resolve, reject) => {
                api.sendRequest('contracts/create-all', { branchId, leadId, language })
                    .then(ans => {
                        actions.dispatch('notifications/success', {
                            title: 'Success',
                            text: 'All contracts created'
                        }, { root: true });
                        resolve(ans);
                    })
                    .catch(error => {
                        actions.dispatch('notifications/error', {
                            title: 'Error',
                            text: error.message || 'Failed to create contracts'
                        }, { root: true });
                        reject(error.message || error);
                    });
            });
        },

        getUnsignedContracts({ commit }) {
            return new Promise((resolve, reject) => {
                api.get('contracts/unsigned')
                    .then(ans => {
                        commit('setUnsignedContracts', ans.Contracts || []);
                        resolve(ans);
                    })
                    .catch(error => {
                        commit('setUnsignedContracts', []);
                        reject(error.message || error);
                    });
            });
        },

        signContract(actions, { id, signatureData, signerName }) {
            return new Promise((resolve, reject) => {
                api.sendRequest('contracts/sign/' + id, null, { signatureData, signerName })
                    .then(ans => {
                        actions.commit('resetUnsignedCheck');
                        actions.dispatch('notifications/success', {
                            title: 'Success',
                            text: 'Contract signed successfully'
                        }, { root: true });
                        resolve(ans);
                    })
                    .catch(error => {
                        actions.dispatch('notifications/error', {
                            title: 'Error',
                            text: error.message || 'Failed to sign contract'
                        }, { root: true });
                        reject(error.message || error);
                    });
            });
        },

        updateContract(actions, { id, contract }) {
            return new Promise((resolve, reject) => {
                api.sendRequest('contracts/update/' + id, null, contract)
                    .then(ans => {
                        actions.dispatch('notifications/success', {
                            title: 'Success',
                            text: 'Contract updated'
                        }, { root: true });
                        resolve(ans);
                    })
                    .catch(error => {
                        actions.dispatch('notifications/error', {
                            title: 'Error',
                            text: error.message || 'Failed to update contract'
                        }, { root: true });
                        reject(error.message || error);
                    });
            });
        },

        sendContract(actions, { id }) {
            return new Promise((resolve, reject) => {
                api.sendRequest('contracts/send/' + id)
                    .then(ans => {
                        actions.dispatch('notifications/success', {
                            title: 'Success',
                            text: 'Contract sent by email'
                        }, { root: true });
                        resolve(ans);
                    })
                    .catch(error => {
                        actions.dispatch('notifications/error', {
                            title: 'Error',
                            text: error.message || 'Failed to send contract'
                        }, { root: true });
                        reject(error.message || error);
                    });
            });
        },

        resendContract(actions, { id }) {
            return new Promise((resolve, reject) => {
                api.sendRequest('contracts/resend/' + id)
                    .then(ans => {
                        actions.dispatch('notifications/success', {
                            title: 'Success',
                            text: 'Contract resent'
                        }, { root: true });
                        resolve(ans);
                    })
                    .catch(error => reject(error.message || error));
            });
        },

        uploadSignedPdf(actions, { id, file, signingSuccessful }) {
            return new Promise((resolve, reject) => {
                api.uploadFile('contracts', 'upload-signed/' + id, file, { signingSuccessful })
                    .then(ans => {
                        actions.dispatch('notifications/success', {
                            title: 'Success',
                            text: signingSuccessful ? 'Contract signed successfully' : 'File uploaded'
                        }, { root: true });
                        resolve(ans);
                    })
                    .catch(error => {
                        actions.dispatch('notifications/error', {
                            title: 'Error',
                            text: error.message || 'Failed to upload file'
                        }, { root: true });
                        reject(error.message || error);
                    });
            });
        },

        cancelContract(actions, { id }) {
            return new Promise((resolve, reject) => {
                api.sendRequest('contracts/cancel/' + id)
                    .then(ans => {
                        actions.dispatch('notifications/success', {
                            title: 'Success',
                            text: 'Contract cancelled'
                        }, { root: true });
                        resolve(ans);
                    })
                    .catch(error => reject(error.message || error));
            });
        },

        deleteContract(actions, { id }) {
            return new Promise((resolve, reject) => {
                api.sendRequest('contracts/delete/' + id)
                    .then(ans => {
                        actions.dispatch('notifications/success', {
                            title: 'Success',
                            text: 'Contract deleted'
                        }, { root: true });
                        resolve(ans);
                    })
                    .catch(error => reject(error.message || error));
            });
        },

        downloadPdf(actions, { id }) {
            const url = window.config.apiUrl + 'contracts/download/' + id;
            const headers = { 'Authorization': 'Bearer ' + localStorage.Bearer };
            return fetch(url, { headers })
                .then(res => {
                    if (!res.ok) throw new Error('Download failed');
                    const disposition = res.headers.get('Content-disposition') || '';
                    const match = disposition.match(/filename=(.+)/);
                    const fileName = match ? match[1] : 'contract.pdf';
                    return res.blob().then(blob => ({ blob, fileName }));
                })
                .then(({ blob, fileName }) => {
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    URL.revokeObjectURL(link.href);
                });
        },

        downloadSignedPdf(actions, { id }) {
            const url = window.config.apiUrl + 'contracts/download-signed/' + id;
            const headers = { 'Authorization': 'Bearer ' + localStorage.Bearer };
            return fetch(url, { headers })
                .then(res => {
                    if (!res.ok) throw new Error('Download failed');
                    const disposition = res.headers.get('Content-disposition') || '';
                    const match = disposition.match(/filename=(.+)/);
                    const fileName = match ? match[1] : 'signed_contract.pdf';
                    return res.blob().then(blob => ({ blob, fileName }));
                })
                .then(({ blob, fileName }) => {
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    URL.revokeObjectURL(link.href);
                });
        },
    }
};
